var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 346,
    viewBox: "0 0 346 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162 345.4H183.3C188.6 345.4 192.9 341.1 192.9 335.8V257.1C192.9 251.8 188.6 247.5 183.3 247.5H162C156.7 247.5 152.4 251.8 152.4 257.1V335.8C152.4 341.1 156.7 345.4 162 345.4Z",
    fill: "#E5B265"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162 98H183.3C188.6 98 192.9 93.7 192.9 88.4V9.6C192.9 4.3 188.6 0 183.3 0H162C156.7 0 152.4 4.3 152.4 9.6V88.3C152.4 93.7 156.7 98 162 98Z",
    fill: "#E5B265"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59999 193H88.3C93.6 193 97.9 188.7 97.9 183.4V162.1C97.9 156.8 93.6 152.5 88.3 152.5H9.59999C4.29999 152.5 0 156.8 0 162.1V183.4C0 188.7 4.29999 193 9.59999 193Z",
    fill: "#E5B265"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.4 162V183.3C247.4 188.6 251.7 192.9 257 192.9H335.7C341 192.9 345.3 188.6 345.3 183.3V162C345.3 156.7 341 152.4 335.7 152.4H257C251.7 152.4 247.4 156.7 247.4 162Z",
    fill: "#E5B265"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9996 287.3L58.0996 302.4C61.8996 306.2 67.9996 306.2 71.6996 302.4L127.4 246.7C131.2 242.9 131.2 236.8 127.4 233.1L112.3 218C108.5 214.2 102.4 214.2 98.6996 218L42.9996 273.7C39.2996 277.4 39.2996 283.5 42.9996 287.3Z",
    fill: "#E5B265"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.1 127.4C236.9 131.2 243 131.2 246.7 127.4L302.4 71.6999C306.2 67.8999 306.2 61.7999 302.4 58.0999L287.3 42.9999C283.5 39.1999 277.4 39.1999 273.7 42.9999L218 98.6999C214.2 102.5 214.2 108.6 218 112.3L233.1 127.4Z",
    fill: "#E5B265"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo_mini.230e60a7a9945a5956d25d2fe407318e.svg";
export { ForwardRef as ReactComponent };